import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Tooltip } from "antd";
import { PushpinFilled, PushpinOutlined } from "@ant-design/icons";
import { actions as commonActions } from "../../store/commonRedux/actions";
import toast from "../../utils/toast";
import styles from "./styles.module.css";

/**
 * Pin a project to the sidebar.
 *
 * Kept in the browser rather than on the server: a pin is a shortcut, not data
 * about the project, and nothing else in the product depends on it. The cost is
 * that it does not follow the user to another device — the same trade the quick
 * access shortcuts already make.
 *
 * Pins are stored per organization, and store the project itself rather than an
 * id, so the sidebar can render them without looking anything up.
 */
const PinProjectButton = ({ project, size = "small", withLabel = false }) => {
  const dispatch = useDispatch();

  const orgUuid = useSelector(({ auth }) => auth.organization?.uuid);
  const pins = useSelector(({ common }) => common.projectPins?.[orgUuid]);

  const isPinned = (pins || []).some((item) => item.uuid === project?.uuid);

  const toggle = (event) => {
    /* The card behind this button is a link to the project. */
    event.preventDefault();
    event.stopPropagation();

    if (!orgUuid || !project?.uuid) return;

    dispatch(
      commonActions.toggleProjectPin(orgUuid, {
        uuid: project.uuid,
        title: project.title,
        image: project.main_image?.original_url || null,
      }),
    );

    toast.success(
      isPinned ? "از سنجاق‌شده‌ها حذف شد" : "به سنجاق‌شده‌ها اضافه شد",
    );
  };

  return (
    <Tooltip title={isPinned ? "برداشتن سنجاق" : "سنجاق به منوی کناری"}>
      <Button
        type="text"
        size={size}
        className={`${styles.button} ${isPinned ? styles.pinned : ""}`}
        icon={isPinned ? <PushpinFilled /> : <PushpinOutlined />}
        onClick={toggle}
      >
        {withLabel ? (isPinned ? "سنجاق‌شده" : "سنجاق") : null}
      </Button>
    </Tooltip>
  );
};

export default PinProjectButton;
